import {formSettings, FormSettings} from '../../../bps/components/form/formSettings';

formSettings.checkboxIsSwitch = true;
formSettings.remainSignedIn = true;
formSettings.addressForm = {
  showPhone: false,
};

export {formSettings, FormSettings};
